import React, { useMemo, useState } from 'react';
import { AlarmTriggerOptions } from '@utils/alarmsConstants';
import { Button, Form, Select, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';

export function TriggerTypeField() {
  const { t } = useTranslation('create-alarm-step');
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    undefined,
  );
  const alarmTypeOptions = [
    {
      value: AlarmTriggerOptions.THRESHOLD,
      label: t(
        'create-alarm-step:stepTwo.createAlarmTriggerTypeThresholdField',
      ),
    },
    {
      value: AlarmTriggerOptions.PERCENTUAL_VARIATION,
      label: t(
        'create-alarm-step:stepTwo.createAlarmTriggerTypePercentualVariationField',
      ),
    },
    {
      value: AlarmTriggerOptions.SEASONAL,
      label: t('create-alarm-step:stepTwo.createAlarmTriggerTypeSeasonalField'),
    },
  ];

  const alarmTypeTooltipOptions = useMemo(
    () => [
      {
        value: AlarmTriggerOptions.THRESHOLD,
        label: t('create-alarm-step:stepTwo.createAlarmThresholdTooltip'),
      },
      {
        value: AlarmTriggerOptions.PERCENTUAL_VARIATION,
        label: t(
          'create-alarm-step:stepTwo.createAlarmPercentVariationTooltip',
        ),
      },
      {
        value: AlarmTriggerOptions.SEASONAL,
        label: t('create-alarm-step:stepTwo.createAlarmSeasonalTooltip'),
      },
    ],
    [t],
  );

  const currentTooltip = useMemo(() => {
    if (!selectedValue) return null;
    return alarmTypeTooltipOptions.find(
      option => option.value === selectedValue,
    )?.label;
  }, [selectedValue, alarmTypeTooltipOptions]);

  return (
    <Form.Item
      name="tipoAlarme"
      label={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {t('create-alarm-step:stepTwo.createAlarmTriggerTypeField')}
          {currentTooltip && (
            <Tooltip title={currentTooltip} trigger="hover">
              <Button type="link" icon={<QuestionCircleOutlined />} />
            </Tooltip>
          )}
        </div>
      }
      rules={[
        {
          required: true,
          message: t(
            'create-alarm-step:stepTwo.createAlarmTriggerTypeFieldRequired',
          ),
        },
      ]}
    >
      <Select
        style={{ textAlign: 'left' }}
        allowClear
        options={alarmTypeOptions}
        onChange={value => {
          setSelectedValue(value);
        }}
      />
    </Form.Item>
  );
}
